var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3878 5.23759L12.9351 2.42779L10.0557 2.87183L8 0.855469L5.93692 2.90094L3.06493 2.43507L2.61224 5.22303L0.00742115 6.54058L1.32096 9.06648L0 11.6142L2.58998 12.9099L3.05009 15.7416L5.91466 15.2757L7.97774 17.3139L10.0334 15.3048L12.9202 15.7488L13.3729 12.9391L16 11.6361L14.679 9.08832L15.9926 6.54058L13.3878 5.23759ZM5.03125 6.54111C5.03125 5.93807 5.52963 5.44922 6.14442 5.44922C6.75921 5.44922 7.2576 5.93807 7.2576 6.54111C7.2576 7.14414 6.75921 7.633 6.14442 7.633C5.52963 7.633 5.03125 7.14414 5.03125 6.54111ZM9.85536 10.5449C9.24057 10.5449 8.74219 11.0338 8.74219 11.6368C8.74219 12.2398 9.24057 12.7287 9.85536 12.7287C10.4701 12.7287 10.9685 12.2398 10.9685 11.6368C10.9685 11.0338 10.4701 10.5449 9.85536 10.5449ZM11.7102 6.4756L5.33544 12.7285L4.28906 11.7021L10.6638 5.44922L11.7102 6.4756Z",
    fill: "#FF4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.477dcb52d7e22c2d33a6eb8c878c4795.svg";
export { ForwardRef as ReactComponent };